// Design tokens for "peeps" — dark-first, tactile ticket aesthetic.
export const colors = {
  surface: "#15161E",
  onSurface: "#F8F9FA",
  surfaceSecondary: "#20212C",
  onSurfaceSecondary: "#E5E7EB",
  surfaceTertiary: "#2C2D3A",
  onSurfaceTertiary: "#9CA3AF",
  surfaceInverse: "#FFFFFF",
  onSurfaceInverse: "#15161E",
  brand: "#8B7CF6",
  brandSecondary: "#A594FF",
  brandTertiary: "#322B59",
  onBrand: "#FFFFFF",
  success: "#43E8C9",
  onSuccess: "#062922",
  warning: "#FF8A5B",
  error: "#F87171",
  border: "#2C2D3A",
  borderStrong: "#4A4B5C",
  muted: "#6B6B7D",
  faint: "#5C5D70",
};

export const groupThemes = {
  violet: { solid: "#A594FF", grad: ["#A594FF", "#5B3FE0"], on: "#15161E" },
  coral: { solid: "#FF8A5B", grad: ["#FF8A5B", "#D8451F"], on: "#3B1100" },
  lime: { solid: "#43E8C9", grad: ["#43E8C9", "#158F79"], on: "#062922" },
  sky: { solid: "#5AB8FF", grad: ["#5AB8FF", "#1E6FE0"], on: "#04203F" },
  rose: { solid: "#FF7EB6", grad: ["#FF7EB6", "#C4267D"], on: "#3F0620" },
  amber: { solid: "#FFC24B", grad: ["#FFC24B", "#D98A00"], on: "#3B2800" },
};

export const themeOf = (key) => groupThemes[key] || groupThemes.violet;

export const gradientCss = (grad) =>
  `linear-gradient(135deg, ${grad[0]} 0%, ${grad[1]} 100%)`;

export function initials(name) {
  if (!name) return "•";
  return name
    .trim()
    .split(/\s+/)
    .map((p) => p[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();
}
